import React, { useState } from "react";
import { saveUserFeedback } from "../../commons/Utils";
import * as Commons from "oc-commons/Commons";
import { I18N } from "oc-I18N";
import * as Dialogs from "oc-ui/dialogs/Dialogs";

export function showFeedbackDialog() {
  const removeDialogFunction: any = Dialogs.showDialog({
    content: <Feedback removeDialogFunction={() => removeDialogFunction()}></Feedback>,
  });
}

function Feedback({ removeDialogFunction }: { removeDialogFunction: () => void }) {
  const [text, setText] = useState("");
  const [checked, setChecked] = useState(false);
  const isDisabled = !checked || text == "";
  return (
    <div
      className="feedback-dialog"
      role="dialog"
      aria-labelledby="feedback-title"
      aria-modal="true"
    >
      <h2 id="feedback-title" className="sr-only">
        {I18N("aria::Feedback senden")}
      </h2>
      <p dangerouslySetInnerHTML={{ __html: I18N("Bitte schreiben sie uns:") }}></p>
      <label htmlFor="feedback-textarea" className="sr-only">
        {I18N("aria::Ihr Feedback")}
      </label>
      <textarea
        id="feedback-textarea"
        className="feedback"
        autoFocus={true}
        onChange={(e) => setText(e.target.value)}
        value={text}
        aria-required="true"
        aria-label={I18N("aria::Ihr Feedback")}
        placeholder={I18N("Ihr Feedback...")}
      />
      <label htmlFor="feedback-consent">
        <input
          id="feedback-consent"
          type="checkbox"
          checked={checked}
          onChange={() => setChecked(!checked)}
          aria-required="true"
        />
        <span
          dangerouslySetInnerHTML={{ __html: I18N("ich stimme der Speicherung meiner Daten zu") }}
        ></span>
      </label>
      <div className="button-container" role="group" aria-label={I18N("aria::Aktionen")}>
        <button
          className="outlined-button"
          onClick={() => removeDialogFunction()}
          aria-label={I18N("Abbrechen")}
        >
          {I18N("Abbrechen")}
        </button>
        <button
          className="primary-button"
          disabled={isDisabled}
          aria-disabled={isDisabled}
          aria-label={I18N("Abschicken")}
          onClick={async () => {
            await saveUserFeedback(text);
            removeDialogFunction();
            await Commons.sleep(1000);
            Dialogs.showToast(I18N("Vielen Dank"), { delay: 8000 });
          }}
        >
          {I18N("Abschicken")}
        </button>
      </div>
    </div>
  );
}
